/**
 * @generated SignedSource<<be6c953ce25cbbc271ffd21dedfb578c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpacesComponent_workspace$data = {
  readonly id: string;
  readonly spaces: ReadonlyArray<{
    readonly height: number;
    readonly id: string;
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceItem_storecastSpace">;
  }>;
  readonly " $fragmentType": "OrgSpacesComponent_workspace";
};
export type OrgSpacesComponent_workspace$key = {
  readonly " $data"?: OrgSpacesComponent_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpacesComponent_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgSpacesComponent_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastSpace",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrgSpaceItem_storecastSpace"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "37abdbaa5b12c4f0ac083e17233b6a6d";

export default node;
